import '../../partials/users/register/register-form';
